import axiosClient from '../axiosClient';

const authAPI = {
    async loginAPI(data) {
        const url = `/auth/login`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async registerAPI(data) {
        const url = `/auth/register`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async getProfileAPI() {
        const url = `/user/profile`;
        const resp = await axiosClient.get(url);
        return resp;
    },

    async updateProfileAPI(data) {
        const url = `/user/profile`;
        const resp = await axiosClient.put(url, data);
        return resp;
    },

    async checkPhoneAPI(data) {
        const url = `/auth/check_exists_phone_number`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async forgotPassAPI(data) {
        const url = `auth/set_password_login_with_phone`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async changePassAPI(data) {
        const url = `auth/change_password`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async userRegsiterTesting(data) {
        const url = `user_regsiter_testing`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async loginOTP(data) {
        const url = `auth/login_otp`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async loginWithPhone(data) {
        const url = `auth/login_with_phone`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },

    async refreshToken(data) {
        const url = `auth/refresh`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },
};

export default authAPI;
